import React from 'react';
import { Box, Card, Typography, Divider } from '@mui/material';

interface EmptyStateProps {
  icon?: string;
  title: string;
  message: string;
  tip?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon = '📁',
  title,
  message,
  tip
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        px: 3,
        py: 8
      }}
    >
      <Card
        sx={{
          maxWidth: 500,
          textAlign: 'center',
          bgcolor: 'background.paper',
          borderRadius: 3,
          boxShadow: 3,
          p: 4
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            bgcolor: 'primary.main',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
            opacity: 0.9
          }}
        >
          <Typography variant="h2" sx={{ color: 'white', fontSize: '2.5rem' }}>
            {icon}
          </Typography>
        </Box>
        <Typography variant="h5" gutterBottom fontWeight={600} color="text.primary">
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 2, mb: tip ? 3 : 0 }}>
          {message}
        </Typography>
        {tip && (
          <>
            <Divider sx={{ my: 2 }} />
            <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
              💡 {tip}
            </Typography>
          </>
        )}
      </Card>
    </Box>
  );
};

export default EmptyState;
